import { render, staticRenderFns } from "./OauthSso.vue?vue&type=template&id=4b776042"
import script from "./OauthSso.vue?vue&type=script&lang=js"
export * from "./OauthSso.vue?vue&type=script&lang=js"
import style0 from "./OauthSso.vue?vue&type=style&index=0&id=4b776042&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports